import WebsiteBehaviors from "../website-behaviors/index.js";

class VitalSource extends WebsiteBehaviors {
	identifier() {
		return "VitalSource";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "bookshelf.vitalsource.com" || location.host === "jigsaw.vitalsource.com") && !location.pathname.startsWith("/mosaic/");
	}

	async init() {
		// Observe for and hide the VitalSource popup, since their CSS class
		// names seem unreliable on the popup
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (!mutation.addedNodes)
					return;

				for (const node of Array.from(mutation.addedNodes)) {
					// Set a small timeout because otherwise the VitalSource
					// popup won't be detected in Firefox
					setTimeout(() => {
						if (node.nodeName === "DIV" && (node as any).innerText.includes("Add Note"))
							(node as any).style.display = "none";
					}, 10);
				}
			});
		});

		observer.observe(document.body, {
			childList: true,
			subtree:   true
		});

		this._disablePjax();
	}

	shouldFrameTakeControl() {
		return window.location.hostname === "jigsaw.vitalsource.com"
			&& window.location.pathname !== "/mosaic/wrapper.html";
	}
}

export default VitalSource;
